import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { TemaProvider } from "./theme/ThemeProvider";
import { AuthProvider } from "./auth/AuthContext";
import { GlobalLoaderProvider } from "./components/ui/GlobalLoader";
import { IdiomaProvider } from "./i18n/IdiomaProvider";
import { App } from "./App";
import { carregarConfigVisual } from "./theme/configVisual";
import { inicializarFaviconSistema } from "./utils/faviconSistema";
import { instalarCorretorGlobalMojibake } from "./utils/textoPtBr";
import { bloquearTooltipsNativos } from "./utils/bloquearTooltipsNativos";
import { ErroAplicacaoBoundary } from "./components/ui/ErroAplicacaoBoundary";
import "./styles/theme.css";
import "./styles/base.css";
import "./styles/barraRolagem.css";
import "./styles/dashboard.css";
import "./styles/bloconotas.css";
import "./styles/listagem.css";
import "./styles/notificacoes.css";
import "./styles/cards-plataforma.css";

// Aplica a cor de destaque/gradiente salvos nas Configurações (best-effort).
void carregarConfigVisual();
inicializarFaviconSistema();
instalarCorretorGlobalMojibake();
bloquearTooltipsNativos();

const elementoRaiz = document.getElementById("root");
if (!elementoRaiz) throw new Error('Elemento #root não encontrado no index.html');

createRoot(elementoRaiz).render(
  <StrictMode>
    <ErroAplicacaoBoundary>
      <TemaProvider>
        <GlobalLoaderProvider>
          <IdiomaProvider>
            <AuthProvider>
              <BrowserRouter>
                <App />
              </BrowserRouter>
            </AuthProvider>
          </IdiomaProvider>
        </GlobalLoaderProvider>
      </TemaProvider>
    </ErroAplicacaoBoundary>
  </StrictMode>
);
